module.exports = __webpack_public_path__ + "static/media/portfolio-example-02.a7d90e37.jpg";